import type { FC, ReactNode } from 'react';
import { useEffect } from 'react';
import { LuX } from 'react-icons/lu';
import '../RecordPanel.css';

interface Props {
    open: boolean;
    onClose: () => void;
    /** Quadrado com a cor da marca, à esquerda do título. */
    icone?: ReactNode;
    title: string;
    subtitle?: string;
    /** Rodapé sempre visível — é um fluxo, não um registro em edição. */
    footer?: ReactNode;
    children: ReactNode;
}

/**
 * Painel lateral dos fluxos de conectar (Meta, QR Code). Veste as classes
 * `rp-` do RecordPanel, como o FiltrosPainel faz, porque o RecordPanel só
 * mostra rodapé em modo edição e trocaria a linha de apoio por "Editando…".
 * Mesma largura (460px), mesmo véu, mesmo Esc.
 */
const CxPainel: FC<Props> = ({ open, onClose, icone, title, subtitle, footer, children }) => {
    useEffect(() => {
        if (!open) return;
        const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="rp-overlay" onClick={onClose}>
            <aside className="rp cx-painel" role="dialog" aria-modal="true" aria-label={title} onClick={e => e.stopPropagation()}>
                <header className="rp-head">
                    {icone}
                    <div className="rp-id">
                        <h2 className="rp-title">{title}</h2>
                        {subtitle && <p className="rp-sub">{subtitle}</p>}
                    </div>
                    <button type="button" className="rp-close" onClick={onClose} aria-label="Fechar">
                        <LuX size={14} />
                    </button>
                </header>
                <div className="rp-body">{children}</div>
                {footer && <footer className="rp-foot">{footer}</footer>}
            </aside>
        </div>
    );
};

export default CxPainel;
